import { dispatchClient } from '../clients';
import { UserFlowRequest } from '@dispatch/shared/types';
import { UserFlowResponse } from '@dispatch/shared/types';

const AUTH_USERFLOW_URL = 'authorization/userflows';

export async function determineUserFlow(
  email: string
): Promise<UserFlowResponse> {
  const response = await dispatchClient.post<UserFlowResponse>(
    AUTH_USERFLOW_URL,
    { email } as UserFlowRequest
  );
  return response.data;
}
